import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import {
  LandingColumns,
  LandingColumnsParagraph,
  LandingSection,
  LandingSectionTitle,
} from './LandingView.styled'

export const SecondarySnippet: FC = () => {
  const { seoSnippetText, seoSnippetSecondary } = useShallowEqualSelector(
    ({ landingReducer: { seoSnippetText, seoSnippetSecondary } }) => ({
      seoSnippetText,
      seoSnippetSecondary,
    })
  )

  const text = seoSnippetSecondary || seoSnippetText

  if (text) {
    return (
      <LandingSection>
        <LandingSectionTitle>
          <FormattedMessage
            id="landing.seo_text.title.friendship"
            defaultMessage="Найти новых друзей просто"
          />
        </LandingSectionTitle>
        <LandingColumns>
          {text.split(/\r\n\r/).map((paragraph: string, index: number) => {
            return (
              <LandingColumnsParagraph
                key={index}
                dangerouslySetInnerHTML={{
                  __html: paragraph,
                }}
              />
            )
          })}
        </LandingColumns>
      </LandingSection>
    )
  }

  console.error('SEO snippet text is null')

  return null
}
